export default __webpack_public_path__ + "static/media/discordicon.6c8b916a.png";